export default {
  STORE_CURRENT_CUSTOMER(state, payload) {
    state.currentCustomer = payload;
  },
  STORE_CURRENT_SHOWING(state, payload) {
    state.currentShowing = payload;
  },
  STORE_ALL_RECENT_LISTINGS_WITHOUT_ACTIVE_SHOWING(state, payload) {
    state.allRecentListingsWithoutActiveShowing = payload;
  },
  STORE_ALL_LISTINGS_WITH_ACTIVE_SHOWING(state, payload) {
    state.allListingsWithActiveShowing = payload;
  },
  STORE_CURRENT_SHOWINGS_SLOT_INFO(state, payload) {
    state.currentShowingsSlot = payload;
  },
  STORE_CURRENT_DATA_INFO(state, payload) {
    state.currentData = payload;
  },
  STORE_SELECTED_LISTING_WHITH_ACTIVE_SHOWING(state, payload) {
    state.currentListingWithActiveShowing = payload;
  },
  // EditPrio in Showing component
  SET_CUSTOMER_EDIT_PRIO(state, payload) {
    state.customerEditPrio = payload;
  },
}
